import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';
import { FirebaseVerifyView, FirebaseResetPasswordView } from 'src/auth/view/firebase';

// ----------------------------------------------------------------------

/** **************************************
 * Jwt
 *************************************** */
const Firebase = {
  SignInPage: lazy(() => import('src/pages/auth/sign-in')),
  SignUpPage: lazy(() => import('src/pages/auth/sign-up')),
};

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'sign-in',
        element: (
          <GuestGuard>
            <AuthSplitLayout section={{ title: 'Hi, Welcome back' }}>
              <Firebase.SignInPage />
            </AuthSplitLayout>
          </GuestGuard>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <GuestGuard>
            <AuthSplitLayout section={{ title: 'Forgot your password?' }}>
              <FirebaseResetPasswordView />
            </AuthSplitLayout>
          </GuestGuard>
        ),
      },
      {
        path: 'verify',
        element: (
          <GuestGuard>
            <AuthSplitLayout section={{ title: 'Please check your email!' }}>
              <FirebaseVerifyView />
            </AuthSplitLayout>
          </GuestGuard>
        ),
      },
    ],
  },
];
